export default "__VITE_ASSET__oUxbDR3i__"